export const commentAnchorId = (commentId) => `ticket-comment-${commentId}`;

export const scrollToComment = (commentId) => {
  document
    .getElementById(commentAnchorId(commentId))
    ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
};
